export default __webpack_public_path__ + "static/media/bg_gray_wing_v03_crop.4d6798a2.png";